module.exports = __webpack_public_path__ + "img/21.ec8df612.gif";